import React from 'react';
import { useNavigate } from 'react-router-dom';
import oneWayRoutesData from '../../../data/oneWayRoutesData.json';
import Icon from '../../../components/AppIcon';


const PopularRoutes = () => {
  const navigate = useNavigate();

  const routes = Object.entries(oneWayRoutesData)?.map(([slug, data]) => ({
    slug,
    from: data?.from,
    to: data?.to,
    distance: data?.distance,
    duration: data?.duration,
    price: `₹ ${data?.fareStart}/-`,
    image: data?.image,
    imageAlt: data?.imageAlt,
    popular: data?.popular
  }));

  const handleRouteClick = (route) => {
    navigate(`/route/${route?.slug}`);
    window.scrollTo(0, 0);
  };

  return (
    <section className="py-12 sm:py-14 md:py-16 bg-gradient-to-br from-blue-50 via-white to-orange-50">
      <div className="container mx-auto px-3 sm:px-4">
        <div className="text-center mb-8 sm:mb-10 md:mb-12 animate-fade-in-down">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-orange-500 to-blue-600 mb-3 sm:mb-4">
            One Way Popular Routes
          </h2>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg px-4">
            Affordable one-way taxi services to popular destinations
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
          {routes?.slice(0, 8)?.map((route, index) => (
            <div
              key={index}
              onClick={() => handleRouteClick(route)}
              className="group bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer hover-lift border-2 border-transparent hover:border-blue-400 animate-fade-in-up touch-manipulation"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative h-40 sm:h-44 md:h-48 overflow-hidden image-zoom">
                <img
                  src={route?.image}
                  alt={route?.imageAlt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                <div className="absolute bottom-2 sm:bottom-3 left-2 sm:left-3 right-2 sm:right-3">
                  <h3 className="text-white font-bold text-base sm:text-lg mb-0.5 sm:mb-1 transition-transform duration-300 group-hover:translate-x-2">
                    {route?.from} to {route?.to}
                  </h3>
                  <p className="text-blue-200 text-xs sm:text-sm transition-transform duration-300 group-hover:translate-x-2">
                    Starting at ₹{route?.fareStart?.toLocaleString('en-IN')}
                  </p>
                </div>
              </div>
              <div className="p-3 sm:p-4">
                <button className="w-full py-2 sm:py-2.5 text-sm sm:text-base bg-gradient-to-r from-blue-500 to-orange-500 hover:from-blue-600 hover:to-orange-600 active:from-blue-700 active:to-orange-700 text-white font-bold rounded-lg transition-all duration-300 btn-hover transform hover:scale-105 active:scale-95 touch-manipulation">
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 sm:mt-10 animate-fade-in">
          <button
            onClick={() => {
              navigate('/popular-cities');
              window.scrollTo(0, 0);
            }}
            className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base bg-gradient-to-r from-blue-600 to-orange-600 hover:from-blue-700 hover:to-orange-700 active:from-blue-800 active:to-orange-800 text-white font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95 btn-hover touch-manipulation"
          >
            <span>View All Routes</span>
            <Icon name="ArrowRight" size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default PopularRoutes;